import axios from 'axios'
import React, { useContext, useState } from 'react'
import AutoCompletePoI from 'src/components/autocomplete/AutocompletePoi'
import { IAddress } from 'src/Interface'
import Button from '../../../button/Button'
import styles from './add-address.module.scss'
import { IState } from 'src/Interface'
import { StateContext, } from '../../../../AppContext'
import { baseApiURL } from 'src/utils/utils'
import { toast } from 'react-toastify'
import TextArea from 'src/components/textArea/TextArea'
import { DispatchContext } from 'src/AppContext'

interface Props {
  branchId: number
  close: () => null
}


const AddAddress: React.FunctionComponent<Props> = ({ close, branchId }: Props) => {
  const state: IState = useContext(StateContext)
  const [address, setAddress] = useState<IAddress>(null)
  const [comment, setComment] = useState('')
  const dispatch = useContext(DispatchContext)

  const createAddress = () => {
    axios.post(`${baseApiURL()}/branches/${branchId}/predefined_addresses`, {
      address,
      comment
    }, {
      headers: {
        Authorization:
          `Bearer ${state.user.accessToken}`
      }
    }).then((result) => {
      return result.data.predefinedAddressId
    }).then((predefinedAddressId) => {
      return axios(`${baseApiURL()}/branches/${branchId}/predefined_addresses/${predefinedAddressId}`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
    }).then((result: any) => {
      dispatch({ type: 'SET_ADDRESSES', addresses: [result.data, ...state.addresses] })
      close()
    }).catch(err => {
      toast(err.response.data.message)
    })
  }

  return (
    <div className={styles.module}>
      <header className={styles.header}>
        <h4>Opret favoritadresser</h4>
      </header>
      <div className={styles.container}>
        <AutoCompletePoI modifiers='tw-mb-3' setAddress={() => setAddress} name='address' label='Adresse' placeholder='Indtast adresse' />
        <TextArea name='comment' value={comment} handleInputChange={() => setComment} placeholder='-' label='Kommentar' />
      </div>
      <footer className={styles.footer}>
        <Button type='secondary' label='Annuller' handleClick={close} />
        <Button disabled={!address} loading={false} type='primary' label='Opret favoritadresse' handleClick={createAddress} />
      </footer>
    </div>
  )
}

export default AddAddress
